import Entity from 'utilities/entity';

class Favorite extends Entity {
    
}

export default new Favorite();